import React, { useContext, useEffect, useState } from 'react';
import {
	TemplateDropdown,
	TemplateField,
} from '../../../components/Attributes/Attributes_old';
import useAsync from '../../../hooks/useAsync';
import Button from '../../../components/Button';
import useLocal from '../../../hooks/useLocal';
import useModal from '../../../hooks/useModal';
import AppContext from '../../../context/AppContext';
import {
	deactivateSelf,
	getAllAvailableTimezones,
	updateUserPasswordv2,
	updateUserProfilev2,
} from '../../../api';
import useChanges from '../../../hooks/useChanges';
import Modal from '../../../components/Shell/Modal';
import { useApp } from '../../../context/AppContextBeta';

const AccountSettings = () => {
	const { get } = useLocal();
	const user = get('user');
	const { logout, onUpdateUser } = useApp();

	const [isChangePasswordModalOpen, setChangePasswordModal] = useState(false);

	const [form, setForm] = useState(user);
	const [newPasswordForm, setNewPasswordForm] = useState({});

	const handleChange = (name, value) => {
		setForm((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handlePasswordChange = (name, value) => {
		setNewPasswordForm((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const { value: timezones } = useAsync(getAllAvailableTimezones);
	const { execute: onUpdateProfile } = useAsync(updateUserProfilev2, {
		immediate: false,
		showNotification: { success: 'Profile updated', error: 'raw' },
	});
	const { execute: onUpdatePassword } = useAsync(updateUserPasswordv2, {
		immediate: false,
		showNotification: { success: 'Password updated', error: 'raw' },
	});

	const { execute: onDeactivateSelf } = useAsync(deactivateSelf, {
		immediate: false,
	});

	const { setOpen: openDeactiveModal } = useModal('deleteModal');

	const timezoneOptions = timezones?.data?.map((timezone) => ({
		label: timezone?.name,
		value: timezone?.label,
	}));

	const [hasChanges, changes] = useChanges(form, user);
	const [hasNewPassword, newPasswordChanges] = useChanges(newPasswordForm, {});

	return (
		<>
			<div>
				<h2 className="text-base font-semibold leading-6 text-gray-900">
					Profile
				</h2>
				<dl className="mt-6 space-y-2 divide-y divide-gray-100 border-t border-gray-200 text-xs leading-6">
					<div className="pt-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs text-gray-400 pt-2">
							Email
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-2 mb-1 ">
							<div className="text-gray-900">
								<TemplateField
									className="w-64"
									value={user?.email}
									onChange={() => {}}
									disabled
								/>
							</div>
						</dd>
					</div>
					<div className="pt-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs text-gray-400 pt-2">
							Account Type
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-2 mb-1 ">
							<div className="text-gray-900">
								<TemplateField
									className="w-64"
									value={user?.role?.displayName}
									onChange={() => {}}
									disabled
								/>
							</div>
						</dd>
					</div>
					<div className="pt-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs text-gray-400 pt-2">
							First Name
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-2 mb-1 ">
							<div className="text-gray-900">
								<TemplateField
									className="w-64"
									dataIndex="firstName"
									value={form?.firstName}
									onChange={handleChange}
								/>
							</div>
						</dd>
					</div>
					<div className="pt-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs text-gray-400 pt-2">
							Last Name
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-2 mb-1 ">
							<div className="text-gray-900">
								<TemplateField
									className="w-64"
									dataIndex="lastName"
									value={form?.lastName}
									onChange={handleChange}
								/>
							</div>
						</dd>
					</div>
					<div className="pt-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs text-gray-400 pt-2">
							Password
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-2 mb-1 ">
							<div className="text-gray-900">
								<div className="-ml-3">
									<Button
										type="secondary"
										onClick={() => setChangePasswordModal(true)}
									>
										Change Password
									</Button>
								</div>
							</div>
						</dd>
					</div>
					<div className="pt-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs text-gray-400 pt-2">
							Timezone
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-2 mb-1 ">
							<div className="text-gray-900">
								<TemplateDropdown
									className="w-64"
									options={timezoneOptions}
									dataIndex="timezone"
									value={form?.timezone}
									onChange={handleChange}
								/>
							</div>
						</dd>
					</div>
				</dl>
				<div className="flex justify-end">
					<Button
						disabled={!hasChanges}
						onClick={() =>
							onUpdateProfile(changes, (response) => {
								if (response.status) {
									const user = onUpdateUser(changes);
									setForm(user);
								}
							})
						}
					>
						{false ? 'Saving...' : 'Save'}
					</Button>
				</div>
			</div>

			<div className="mt-10">
				<h2 className="text-base font-semibold leading-6 text-gray-900">
					Account
				</h2>
				<dl className="mt-6 space-y-2 divide-y divide-gray-100 border-t border-gray-200 text-xs leading-6">
					<div className="pt-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs text-gray-400 pt-2">
							Deactivation
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-2 mb-1 ">
							<div className="text-gray-900">
								<div className="-ml-3">
									<Button
										type="danger"
										onClick={() =>
											openDeactiveModal({
												onConfirm: () => {
													onDeactivateSelf(null, () => logout());
												},
												confirmText: 'Deactivate Account',
												title:
													'Are you sure you want to deactivate this account?',
											})
										}
									>
										Deactivate Account
									</Button>
								</div>
							</div>
						</dd>
					</div>
				</dl>
			</div>

			<Modal
				title="Change Password"
				open={isChangePasswordModalOpen}
				onClose={() => setChangePasswordModal(false)}
			>
				<div className="space-y-4">
					<TemplateField
						name="Current Password"
						dataIndex="currentPassword"
						value={newPasswordForm?.currentPassword}
						onChange={handlePasswordChange}
						autoFocus
						type="password"
					/>
					<TemplateField
						name="New Password"
						dataIndex="newPassword"
						value={newPasswordForm?.newPassword}
						onChange={handlePasswordChange}
						type="password"
					/>
					<TemplateField
						name="Confirm New Password"
						dataIndex="confirmNewPassword"
						value={newPasswordForm?.confirmNewPassword}
						onChange={handlePasswordChange}
						type="password"
					/>
					<div className="flex justify-end">
						<Button
							disabled={
								!hasNewPassword ||
								!newPasswordChanges?.currentPassword ||
								newPasswordChanges?.newPassword !==
									newPasswordChanges?.confirmNewPassword
							}
							onClick={() => {
								onUpdatePassword(
									{
										currentPassword: newPasswordChanges?.currentPassword,
										newPassword: newPasswordChanges?.newPassword,
									},
									() => {
										setChangePasswordModal(false);
										setNewPasswordForm({});
									},
								);
							}}
						>
							Change Password
						</Button>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default AccountSettings;
